import React, { useState } from 'react';
import { absoluteUrl } from '../api/mockApi';

/**
 * Round profile photo for a driver or PA.
 *
 * photoUrl is stored server-relative ('/uploads/123.jpg'), so it is resolved
 * against the API origin rather than the panel's own host. When there is no
 * photo — or the file 404s because it was removed from the server's uploads
 * directory — it degrades to an initials circle rather than a broken image.
 */
const Avatar = ({ name, photoUrl, size = 40, onClick }) => {
  const [failed, setFailed] = useState(false);
  const initial = String(name || '?').trim().charAt(0).toUpperCase() || '?';
  const src = photoUrl ? absoluteUrl(photoUrl) : '';
  const showImage = Boolean(src) && !failed;

  const base = {
    width: size,
    height: size,
    borderRadius: '50%',
    flex: `0 0 ${size}px`,
    objectFit: 'cover',
    border: '2px solid var(--border-gold)',
    backgroundColor: '#F0F0F0',
    cursor: onClick ? 'pointer' : 'default',
  };

  if (showImage) {
    return (
      <img
        src={src}
        alt={name ? `${name} verification selfie` : 'Verification selfie'}
        title={name || ''}
        style={base}
        onError={() => setFailed(true)}
        onClick={onClick}
      />
    );
  }

  return (
    <div
      style={{
        ...base,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--gold-primary)',
        fontWeight: 800,
        fontSize: Math.round(size * 0.42),
        userSelect: 'none',
      }}
      title={photoUrl ? 'Photo unavailable' : 'No verification selfie yet'}
      onClick={onClick}
    >
      {initial}
    </div>
  );
};

export default Avatar;
